export default 
[
  {
    "last_active_at": new Date(),
    "profession_identity":"应届生",
    "years_of_work_experience":1,
    "hr_permission_state":"",
    "is_favorite":false,
    "recent_edu_index":0,
    "resume": {
    "_index": "resumes-2020-09-25-20-15-55",
    "_type": "resumes",
    "_id": "5143255",
    "_score": 624.2072,
    "_source": {
      "resume": {
        "skills": [{
          "description": "WordUnity3DTableau11Unity3D"
        }],
        "work_experiences": [{
            "end_at": "",
            "company_name": "联想（北京）有限公司",
            "still_active": true,
            "description": "",
            "location": "",
            "start_at": "2020-12-01 00:00:00",
            "present": "至今",
            "job_title": "产品实习生"
          },
          {
            "end_at": "2020-09-01 00:00:00",
            "company_name": "深圳市创客工场科技有限公司（C轮）",
            "still_active": true,
            "description": "",
            "location": "",
            "start_at": "2020-07-01 00:00:00",
            "present": "",
            "job_title": "产品经理实习生"
          }
        ],
        "basic_info": {
          "expected_location": [
            "北京"
          ],
          "years_of_work_experience": 1,
          "gender": "",
          "avatar_url": "https://files.wondercv.com/%E5%BC%A0%E6%99%93%E6%B6%B5.png",
          "expected_salary": "",
          "predicted_location": [
            "北京"
          ],
          "name": "张**",
          "degree": "硕士",
          "profession_identity": "应届生",
          "graduate_at": 2021
        },
        "education_experiences": [
          {
            "end_at": "2021-06-01 00:00:00",
            "major": "国际经济与贸易",
            "school_tags": [
              "211",
              "985",
              "双一流",
              "一流大学建设高校A类"
            ],
            "still_active": true,
            "degree": "硕士",
            "school_name": "清华大学",
            "location": "",
            "start_at": "2018-09-01 00:00:00"
          },
          {
            "end_at": "2018-06-01 00:00:00",
            "major": "工商管理",
            "school_tags": [
              "211",
              "985",
              "双一流",
              "一流大学建设高校A类"
            ],
            "still_active": true,
            "degree": "本科",
            "school_name": "清华大学",
            "location": "",
            "start_at": "2014-09-01 00:00:00"
          }],
        "custom_sections": [

        ],
        "profile": {
          "id": 5171176,
          "city": null,
          "kind": null,
          "cv_id": 6721619,
          "email": "a****@wondercv.com",
          "phone": "1-1****330032",
          "degree": "硕士",
          "ethnic": null,
          "gender": null,
          "height": null,
          "wechat": "",
          "weight": null,
          "address": "",
          "exp_job": null,
          "birthday": null,
          "homepage": null,
          "hometown": null,
          "marriage": null,
          "username": "张**",
          "linked_in": "",
          "mentor_id": null,
          "avatar_url": "https://files.wondercv.com/%E5%BC%A0%E6%99%93%E6%B6%B5.png",
          "contact_id": null,
          "created_at": "2020-11-10T05:30:53.622670Z",
          "expired_at": null,
          "updated_at": "2020-11-10T05:30:53.622971Z",
          "current_job": null,
          "format_pref": {
            "age_birthday": {
              "chosen": "age",
              "date_format": ""
            }
          },
          "expected_salary": null,
          "political_status": null
        },
        "orgs": [{
          "id": 8476040,
          "dept": "部门部门",
          "kind": null,
          "name": "以外经历23",
          "cv_id": null,
          "title": "角色角色",
          "end_at": null,
          "hidden": false,
          "present": "至今",
          "user_id": 5143255,
          "language": "cn",
          "position": null,
          "start_at": "2020-01-01 00:00:00",
          "city_name": {
            "cn": null,
            "en": null
          },
          "mentor_id": null,
          "created_at": "2020-10-06T06:21:36.496798Z",
          "expired_at": null,
          "updated_at": "2020-11-18T07:34:39.280377Z",
          "description": "",
          "is_sub_item": null,
          "cust_city_name": "城市城市",
          "description_hide": null
        }]
      },
      "visibility": "hr_visible",
      "updated_at": "2020-12",
      "user_id": 5143255,
      "id": 1958643,
      "token": "mt3vjKe8"
    },
    "highlight": {
      "resume.work_experiences.description": [
        ""
      ],
      "resume.work_experiences.job_title": [
        "<span class='es-highlighter'>产品</span><span class='es-highlighter'>经理</span>实习生",
        "<span class='es-highlighter'>产品</span>实习生11"
      ]
    }
    },
    "cv_account_token":"cv88029c0147ae4f41",
    "keyword_hit":[
        "产品经理",
        "产品"
    ]
  },
  {
    "last_active_at": new Date(),
    "profession_identity":"已工作",
    "years_of_work_experience":2,
    "hr_permission_state":"",
    "is_favorite":false,
    "recent_edu_index":0,
    "resume": {
      "_index": "resumes-2020-09-25-20-15-55",
      "_type": "resumes",
      "_id": "3570801",
      "_score": 473.75543,
      "_source": {
        "resume": {
          "skills": [{
            "description": "Boss优化运营篮球日语搭建游泳招聘粤语客服迭代功能普通话产品经理项目管理团队管理运营管理数据分析材料科学需求分析产品经理团队管理运营管理数据分析"
          }],
          "work_experiences": [{
              "end_at": "",
              "company_name": "腾讯",
              "still_active": true,
              "description": "",
              "location": "北京",
              "start_at": "2020-01-04",
              "present": "至今",
              "job_title": "Java工程师"
            },
            {
              "end_at": "2020-01-01 00:00:00",
              "company_name": "阿里巴巴",
              "still_active": true,
              "description": "<p>负责需求收集、分析竞品动态和市场动态，对产品需求、交互方式提出创新型的想法，结合具体应用场景设计文案，撰写详细的产品需求文档</p>",
              "location": "",
              "start_at": "2019-05-01 00:00:00",
              "present": "至今",
              "job_title": "Java工程师"
            }
          ],
          "basic_info": {
            "expected_location": [
              "北京"
            ],
            "years_of_work_experience": 1,
            "gender": "",
            "avatar_url": "https://files.wondercv.com/%E6%9D%8E%E5%AE%88%E5%87%AF@2x.png",
            "expected_salary": "",
            "predicted_location": [
              "北京"
            ],
            "name": "李**",
            "degree": "硕士",
            "profession_identity": "已工作",
            "graduate_at": 2019
          },
          "education_experiences": [{
              "end_at": "2019-06-01 00:00:00",
              "major": "计算机科学",
              "school_tags": [
                "双一流",
                "211",
                "一流大学建设高校A类",
                "985"
              ],
              "still_active": true,
              "degree": "硕士",
              "school_name": "清华大学",
              "location": "北京",
              "start_at": "2016-06-01 00:00:00"
            },
            {
              "end_at": "2016-06-01 00:00:00",
              "major": "材料科学与工程",
              "school_tags": [
                "211",
                "985"
              ],
              "still_active": true,
              "degree": "本科",
              "school_name": "西安交通大学",
              "location": "",
              "start_at": "2012-09-01 00:00:00"
            }
          ],
          "custom_sections": [

          ],
          "profile": {
            "id": 5171295,
            "city": null,
            "kind": null,
            "cv_id": 6721802,
            "email": "1****800943@163.com",
            "phone": "186****0943",
            "degree": "硕士",
            "ethnic": null,
            "gender": null,
            "height": null,
            "wechat": "",
            "weight": null,
            "address": "",
            "exp_job": null,
            "birthday": null,
            "homepage": null,
            "hometown": null,
            "marriage": null,
            "username": "李**",
            "linked_in": "",
            "mentor_id": null,
            "avatar_url": "https://files.wondercv.com/%E6%9D%8E%E5%AE%88%E5%87%AF@2x.png",
            "contact_id": null,
            "created_at": "2020-11-14T06:07:43.465942Z",
            "expired_at": null,
            "updated_at": "2020-11-14T06:07:43.468119Z",
            "current_job": null,
            "format_pref": null,
            "expected_salary": null,
            "political_status": null
          },
          "orgs": [{
              "id": 8475955,
              "dept": null,
              "kind": null,
              "name": "腾讯",
              "cv_id": null,
              "title": "产品经理",
              "end_at": null,
              "hidden": false,
              "present": "至今",
              "user_id": 3570801,
              "language": "cn",
              "position": null,
              "start_at": "2020-01-01 00:00:00",
              "city_name": {
                "cn": null,
                "en": null
              },
              "mentor_id": null,
              "created_at": "2020-09-01T03:24:37.229494Z",
              "expired_at": null,
              "updated_at": "2020-09-01T03:24:37.230052Z",
              "description": "<p>做了一款网络优化工具</p>",
              "is_sub_item": null,
              "cust_city_name": null,
              "description_hide": null
            },
            {
              "id": 8476109,
              "dept": "宣传部",
              "kind": null,
              "name": "社联",
              "cv_id": null,
              "title": "宣传干事",
              "end_at": "2020-06-01 00:00:00",
              "hidden": false,
              "present": null,
              "user_id": 3570801,
              "language": "cn",
              "position": null,
              "start_at": "2020-02-01 00:00:00",
              "city_name": {
                "cn": "北京",
                "en": "Beijing"
              },
              "mentor_id": null,
              "created_at": "2020-10-30T07:14:33.353284Z",
              "expired_at": null,
              "updated_at": "2020-10-30T08:47:48.045771Z",
              "description": "<p>协调校团委各部门的工作，协助校团委文体部、组织部，先后组织“闪青”、“彩跑”等大型学院活动，其中彩跑活动参与人数超过1200人<br />创建并运营团委微信公众平台，审核编辑推送内容，报道团委活动，并策划每周选题；已有3000+同学关注，并通过公众号推文形成实习群、活动群等2个500人活跃大群</p>",
              "is_sub_item": null,
              "cust_city_name": "北京",
              "description_hide": null
            }
          ]
        },
        "visibility": "in_private",
        "updated_at": "2020-11",
        "user_id": 3570801,
        "id": 859497,
        "token": "LnHKSLQy"
      },
      "highlight": {
        "resume.work_experiences.description": [
          "<p>负责需求收集、分析竞品动态和市场动态，对<span class='es-highlighter'>产品</span>需求、交互方式提出创新型的想法，结合具体应用场景设计文案，撰写详细的<span class='es-highlighter'>产品</span>需求文档</p>"
        ],
        "resume.skills.description": [
          "Boss优化运营篮球日语搭建游泳招聘粤语客服迭代功能普通话<span class='es-highlighter'>产品</span><span class='es-highlighter'>经理</span>项目管理团队管理运营管理数据分析材料科学需求分析<span class='es-highlighter'>产品</span><span class='es-highlighter'>经理</span>团队管理运营管理数据分析"
        ],
        "resume.work_experiences.job_title": [
          "<span class='es-highlighter'>产品</span><span class='es-highlighter'>经理</span>"
        ]
      }
    },
    "cv_account_token":"cv54400cf489db4904",
    "keyword_hit":[
        "产品经理",
        "产品"
    ]
  },
  {
    "last_active_at": new Date(),
    "profession_identity":"已工作",
    "years_of_work_experience":5,
    "hr_permission_state":"",
    "is_favorite":false,
    "recent_edu_index":0,
    "resume": {
      "_index": "resumes-2020-09-25-20-15-55",
      "_type": "resumes",
      "_id": "163295",
      "_score": 245.38774,
      "_source": {
        "resume": {
          "skills": [{
            "description": "Axure（熟练）、Office办公软件（基础）"
          }],
          "work_experiences": [{
              "end_at": "",
              "company_name": "美团",
              "still_active": true,
              "description": "",
              "location": "上海",
              "start_at": "2020-03-01",
              "present": "至今",
              "job_title": "UI设计师"
            },
            {
              "end_at": "2020-03-01",
              "company_name": "滴滴出行",
              "still_active": true,
              "description": "",
              "location": "上海",
              "start_at": "2018-08-01",
              "present": "",
              "job_title": "UI设计师"
            },
            {
              "end_at": "2017-08-01",
              "company_name": "滴滴出行",
              "still_active": true,
              "description": "",
              "location": "上海",
              "start_at": "2015-12-01",
              "present": "",
              "job_title": "高级产品经理"
            },
            {
              "end_at": "2015-12-01",
              "company_name": "快的打车",
              "still_active": true,
              "description": "",
              "location": "上海",
              "start_at": "2014-01-01",
              "present": "",
              "job_title": "高级产品经理"
            },
            {
              "end_at": "2014-01-01",
              "company_name": "蜻蜓FM",
              "still_active": true,
              "description": "",
              "location": "上海",
              "start_at": "2012-08-01",
              "present": "",
              "job_title": "产品经理"
            },
            {
              "end_at": "2012-08-01",
              "company_name": "土豆网",
              "still_active": true,
              "description": "",
              "location": "北京",
              "start_at": "2011-04-01",
              "present": "",
              "job_title": "产品经理"
            }
          ],
          "basic_info": {
            "expected_location": [

            ],
            "years_of_work_experience": 5,
            "gender": "",
            "avatar_url": "https://files.wondercv.com/taro_searchResume_miniprogram/headImg_square1.png",
            "expected_salary": "",
            "predicted_location": [
              "北京",
              "上海"
            ],
            "name": "黄**",
            "degree": "硕士",
            "profession_identity": "已工作",
            "graduate_at": null
          },
          "education_experiences": [{
              "end_at": "2016-04-01",
              "major": "设计艺术学",
              "school_tags": [
                "211",
                "一流学科建设高校"
              ],
              "still_active": true,
              "degree": "硕士",
              "school_name": "北京邮电大学",
              "location": "北京",
              "start_at": "2013-09-01"
            },
            {
              "end_at": "2013-06-01",
              "major": "工业设计",
              "school_tags": [
                "211",
                "一流学科建设高校"
              ],
              "still_active": true,
              "degree": "本科",
              "school_name": "北京邮电大学",
              "location": "北京",
              "start_at": "2009-08-01"
            }
          ],
          "custom_sections": [

          ],
          "profile": {
            "id": 115574,
            "city": null,
            "kind": null,
            "cv_id": 181111,
            "email": "l****5222@163.com",
            "phone": "180****6255",
            "degree": "硕士",
            "ethnic": "",
            "gender": "",
            "height": "",
            "wechat": "",
            "weight": "",
            "address": "",
            "exp_job": "",
            "birthday": null,
            "homepage": "",
            "hometown": "",
            "marriage": "",
            "username": "黄**",
            "linked_in": "",
            "mentor_id": null,
            "avatar_url": "https://files.wondercv.com/%E9%BB%84%E6%B6%9B.png",
            "contact_id": null,
            "created_at": "2018-04-17T04:16:43.606+08:00",
            "expired_at": null,
            "updated_at": "2018-04-17T04:16:43.606+08:00",
            "current_job": "",
            "format_pref": {

            },
            "expected_salary": "",
            "political_status": null
          },
          "orgs": [

          ]
        },
        "visibility": "in_private",
        "updated_at": "2020-06",
        "user_id": 163295,
        "id": 116469,
        "token": "rIiAfWc"
      },
      "highlight": {
        "resume.work_experiences.description": [
          ""
        ],
        "resume.work_experiences.job_title": [
          "<span class='es-highlighter'>产品</span><span class='es-highlighter'>经理</span>",
          "<span class='es-highlighter'>产品</span><span class='es-highlighter'>经理</span>",
          "高级<span class='es-highlighter'>产品</span><span class='es-highlighter'>经理</span>",
          "高级<span class='es-highlighter'>产品</span><span class='es-highlighter'>经理</span>",
          "高级<span class='es-highlighter'>产品</span><span class='es-highlighter'>经理</span>"
        ]
      }
    },
    "cv_account_token":"cva5997cab5c5f4043",
    "keyword_hit":[
        "产品经理",
        "产品"
    ]
  }
]
